import { ICellFormat } from '@modeso/types__aumico-lib-core-be';
import { RowTypes } from '../../../../aumico-lib-annualreport-fe/src/public-api';

export interface INotesSuperTableRowForPrintPreview {
    rowType: RowTypes; //TABLE_HEAD || ROW || EMPTY_ROW || CALC_ROW || TITLE_ROW
    t: string;
    [key: string]: string | number | null | boolean | ICellFormat; // Value for each column
    format?: ICellFormat;
}
